import api from "./api";

const sliderApi = {
  getAll: async () => {
    try {
      const response = await api.get('/sliders');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/sliders/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  create: async (formData) => {
    try {
      const response = await api.post('/sliders', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  update: async (id, formData) => {
    try {
      const response = await api.put(`/sliders/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`/sliders/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Upload slider image (separate endpoint if needed)
  uploadImage: async (id, imageFile) => {
    try {
      const formData = new FormData();
      formData.append('image', imageFile);
      
      const response = await api.post(`/sliders/${id}/images`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Delete slider image
  deleteImage: async (sliderId, imageId) => {
    try {
      const response = await api.delete(`/sliders/${sliderId}/images/${imageId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default sliderApi;